import {
  PAGE_OVERVIEW, PAGE_METRICS, PAGE_ALARMS, PAGE_SETTINGS, LOGOUT, ORGANISATION_SELECTOR,
} from './types';

import { OrganisationSelectorContainer } from '../components/OrganisationSelector';

export const sidebarLinksTop = [
  {
    pageId: PAGE_OVERVIEW,
    pageTitle: 'overview.title',
    iconName: 'tachometer alternate',
    view: 'all',
  },
  {
    pageId: PAGE_METRICS,
    pageTitle: 'metrics.title',
    iconName: 'chart bar',
    view: 'all',
  },
  {
    pageId: PAGE_ALARMS,
    pageTitle: 'alarms.title',
    iconName: 'alarm',
    view: 'all',
  },
  /*
  {
    pageId: PAGE_REPORT,
    pageTitle: 'Report',
    iconName: 'file alternate',
    view: 'all',
  },
  */
];

export const sidebarLinksBottom = [
  {
    pageId: PAGE_SETTINGS,
    pageTitle: 'settings.title',
    iconName: 'settings',
    view: 'all',
  },
  {
    pageId: ORGANISATION_SELECTOR,
    pageTitle: 'org_selector', // just for the key warning
    component: OrganisationSelectorContainer,
    view: 'all',
  },
  {
    pageId: LOGOUT,
    pageTitle: 'common.logout',
    iconName: 'log out',
    view: 'all',
  },
];



// WEBPACK FOOTER //
// ./src/utils/nav.js